var cifPl = ["301 189", "<g fill='none'><path fill='#FFF' d='M.5.75h300v187.5H.5z'/><path fill='#DC143C' d='M.5 94.5h300v93.75H.5z'/></g>"];

export { cifPl };

